module.exports = __webpack_public_path__ + "static/media/29DUNON16.9cc4c390.jpg";